export const attributeTypes = {
  "xs:float": "float",
  "xs:int": "int",
  "xs:integer": "int",
  "xs:string": "string",
  "xs:boolean": "boolean",
  "xs:ID": "ID",
  "xs:NMTOKENS": "string",
  Script: "script",
  URI: "string",
};
